import { useEffect } from 'react'
import { z } from 'zod'

import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import useInvalidate, { ReturnsNotificationCount } from '../useInvalidate'

export default function useNotificationCount() {
  const invalidate = useInvalidate()

  const result = useApiQuery({
    queryKey: ['useNotificationCount', ReturnsNotificationCount],
    placeholderData: (previousData) => previousData || 0,
    queryFn: async () => {
      const res = await api.get(`notification/count/unread`)
      return z.number().parse(res)
    },
    refetchInterval: 30000,
  })

  useEffect(() => {
    invalidate.notifications()
  }, [result.data || 0])

  return { ...result, notificationCount: result.data || 0 }
}
